import { emailRegex } from '../../../../../shared/utils/formattingUtils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [FormFieldNamesEnum.Email]: val => {
    if (!emailRegex.test(val)) { return 'Invalid email format' }
    if (val.length < 1) { return 'Field is required' }
    return null
  },
  [FormFieldNamesEnum.FirstName]: val => {
    if (val.length < 1) { return 'Field is required' }
    return null
  },
  [FormFieldNamesEnum.LastName]: val => {
    if (val.length < 1) { return 'Field is required' }
    return null
  }
}
